import React from "react";
import { offer } from "../data/offer";
const navItems = [{
  label: "Le contenu",
  href: "#contenu"
}, {
  label: "Les bonus",
  href: "#bonus"
}, {
  label: "Questions",
  href: "#faq"
}];
export function SiteHeader() {
  return <>
      <div className="bg-sage-deep px-4 py-2 text-center" data-id="element-165" data-mp="1nm4svavmkjfw">
        <p className="font-display text-[13px] italic text-cream md:text-sm" data-id="element-166" data-mp="1injr370q5rpc">
          Des moments de foi à partager en famille, une parabole à la fois.
        </p>
      </div>
      <header className="sticky top-0 z-40 border-b border-ink/10 bg-cream/95 backdrop-blur" data-id="element-167" data-mp="qwx65zj9s4ae">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-5" data-id="element-168" data-mp="14wf0svj8ybro">
          <a href="#top" className="font-display text-base font-semibold text-ink md:text-lg" data-id="element-169" data-mp="zxbtf4fsntgj">
            {offer.brand}
          </a>
          <nav aria-label="Navigation principale" className="flex items-center gap-6" data-id="element-170" data-mp="2g9qxmmgl9u4c">
            <ul className="hidden items-center gap-6 md:flex" data-id="element-171" data-mp="2bbz4xq84e3z3">
              {navItems.map(item => <li key={item.href} data-id="element-172" data-mp="29jk7n1bvcbe3">
                  <a href={item.href} className="text-sm font-semibold text-ink-soft transition-colors duration-150 hover:text-ink" data-id="element-173" data-mp="2eiww1qie1qis">
                    {item.label}
                  </a>
                </li>)}
            </ul>
            <a href="#offre" className="whitespace-nowrap rounded-full bg-ink px-4 py-2 text-xs font-extrabold tracking-wide text-cream transition-colors duration-150 hover:bg-sage-deep md:text-sm" data-id="element-174" data-mp="1qtc6gorqbv0j">
              <span className="sm:hidden" data-id="element-175" data-mp="20qqcrvjxv3f4">L’OFFRE</span>
              <span className="hidden sm:inline" data-id="element-176" data-mp="25i8hmup31o5d">DÉCOUVRIR LE MÉGA PACK</span>
            </a>
          </nav>
        </div>
      </header>
    </>;
}